/* eslint-disable react/prop-types */
import React from "react";
import Table from "../../../../components/table/coreUiTable/Table";
import { numberWithCommas } from "../../../../utils/formatters";

const IntroBreakdownTable = ({ table }) => {
  let scopedSlots = () => {
    let scopedSlots = {};

    table.colHeaders.length > 0 &&
      table.colHeaders.forEach((slot) => {
        scopedSlots[slot] = (item) => {
          if (slot.includes("%")) return <td>{item[slot] + "%"}</td>;
          if (slot === "Intros Sold") return <td>{numberWithCommas(item[slot])}</td>;

          return <td>{item[slot]}</td>;
        };
      });

    return scopedSlots;
  };

  return (
    <div>
      <Table
        table={table}
        pagination
        itemsPerPage={9}
        sorter
        scopedSlots={scopedSlots()}
        tableFilter={false}
      />
    </div>
  );
};

export default IntroBreakdownTable;
